import React from "react";
import styled from "styled-components";
function Service() {
  return (
    <Container>
      <TagLine>What we Serve</TagLine>
      <HeadLine>fruit and vegetable delivered to your home</HeadLine>
      <Main>
        <Card>
          <img src="./Group.svg" alt="" />
          <h4>Free shipping</h4>
          <p>Enjoy Order in a hand using the fresness of groceries</p>
        </Card>
        <Card>
          <img src="./Group 1736.svg" alt="" />
          <h4>Secure checkout</h4>
          <p>If you get rotten items - return immediately to us.</p>
        </Card>
        <Card>
          <img src="./Group 1737.svg" alt="" />
          <h4>15 days returns</h4>
          <p>Order in a handy way using the freshness of the groceries.</p>
        </Card>
      </Main>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  margin: auto;
  padding: 40px 0;
  background: #fef5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const TagLine = styled.p`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */

  text-align: center;
  letter-spacing: 0.01em;

  color: #f54748;
  margin-bottom: 5px;
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */
    font-size: 16px;
    line-height: 20px;
  }

  @media only screen and (max-width: 767px) {
    /* Styles */

    font-size: 14px;
  }
`;

const HeadLine = styled.h2`
  font-family: "Poppins";
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 54px;
  /* or 135% */
  width: 600px;
  text-align: center;
  text-transform: capitalize;

  color: #2e2e2e;
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */

    font-size: 30px;
    width: 400px;
    line-height: 42px;
  }
  @media only screen and (max-width: 767px) {
    /* Styles */

    font-size: 25px;
    width: 90%;
    line-height: 38px;
  }
`;

const Main = styled.div`
  display: flex;
  align-items: center;
  width: 75%;
  justify-content: space-evenly;
  margin-top: 30px;
  @media only screen and (max-width: 767px) {
    /* Styles */

    width: 100%;
    flex-direction: column;
  }
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 250px;
  height: 260px;

  background: #ffffff;
  border-radius: 12px;
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */

    width: 200px;
    height: 210px;
    margin-right: 20px;
  }
  @media only screen and (max-width: 767px) {
    /* Styles */

    margin-top: 20px;
  }

  img {
    margin-top: 20px;
    height: 129px;
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      /* Styles */
      height: 90px;
    }
  }

  h4 {
    margin-top: -20px;
    font-family: "Poppins";
    font-weight: 500;
    margin-bottom: 15px;
  }

  p {
    width: 200px;
    font-size: 13px;
    text-align: center;
    font-weight: 400;
    font-family: "Poppins";
    margin-top: -5px;
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      /* Styles */
      font-size: 11px;
    }
  }
`;

export default Service;
